import { render, staticRenderFns } from "./auth-loading.vue?vue&type=template&id=13fbc084&scoped=true"
import script from "./auth-loading.vue?vue&type=script&lang=js"
export * from "./auth-loading.vue?vue&type=script&lang=js"
import style0 from "./auth-loading.vue?vue&type=style&index=0&id=13fbc084&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fbc084",
  null
  
)

export default component.exports